(ns manage.ad-variant.creation.ad-builder.view
  (:require ["@mui/material/Button$default" :as Button]
            ["src/svg/artwork/template.svg$default" :as TemplateArtwork]
            [common.patterns.empty-state-view :refer [empty-state-view]]
            [common.patterns.loading-view :refer [loading-view]]
            [common.queries :refer [use-query]]
            [common.url-template :as url-tpl]
            [manage.ad-variant.creation.ad-builder.modal]
            [manage.ad-variant.creation.ad-builder.table :refer [ad-builders-table]]
            [manage.ad-variant.queries :as q]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui empty-view [{:keys [url-context]}]
  ($ empty-state-view
     {:title "Create ad builders"
      :description "Create ad builders to start ad creation. Whether for products, services,
                    or your brand, find your fit. Let's craft your variants! 🎨"
      :artwork TemplateArtwork
      :docs-href (url-tpl/render :docs/article (assoc url-context :slug "23852211701532-How-to-Create-Ad-Variants"))
      :actions ($ Button
                  {:type "submit"
                   :variant "contained"
                   :onClick #(rf/dispatch [:modal/open {:id :ad-builder/add-template-modal}])}
                  "Create ad builder")
      :sx #js {:height "100%"}}))

(defui ad-builder-view []
  (let [{:keys [adset-id] :as url-context} (use-subscribe [:url-context])
        {:keys [isInitialLoading data] :as ad-builders-upgrade-hints-reponse}
        (use-query (q/ad-builders-upgrade-hints-query {:adset-id adset-id}
                                                      {:show-inactive true}))]
    (cond
      isInitialLoading ($ loading-view)
      (seq data) ($ ad-builders-table
                    {:ad-builders-upgrade-hints-reponse ad-builders-upgrade-hints-reponse})
      :else ($ empty-view {:url-context url-context}))))
